import { createContext } from 'react'

type LocalModalContextValue = {
  closeModal: () => void
}

const LocalModalContext = createContext<LocalModalContextValue>({
  closeModal: () => null,
})

export default LocalModalContext
